<template>
  <div class="d-flex d-row justify-space-between align-baseline pa-4" style="width: 100%; height: 68px;  background-color: #d0d0d0">
    <div class="d-flex d-row align-center mr-2" style="gap: 16px">
      <ApplicationTypeChip :via-request="candidate.viaRequest" />
      <div class="d-flex flex-column" style="width: 640px">
        <ExternalLink
            :to="`/clients/jobs/${candidate.job.id}`"
            primary
            target="_blank"
        >
          <div class="d-flex d-row">
            <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
              {{candidate.job.name}}
            </div>
            <v-icon small>mdi-open-in-new</v-icon>
          </div>
        </ExternalLink>
        <div class="d-flex d-row">
          <div
              class="mr-4 pr-4"
              style="border-right: solid 2px #000;"
          >
            {{fullName}}
          </div>
          <div
              class="mr-4 pr-4"
              v-if="age(candidate.user.birthDate) != null"
              style="border-right: solid 2px #000;"
          >
            {{label("age", [age(candidate.user.birthDate)])}}
          </div>
          <div>
            {{prefecture(candidate.user)}}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex d-row align-self-baseline">
      <ApplicantDetailsButton
          v-if="messageId"
          :user-id="candidate.user.id"
          :target-job="candidate.job"
          label="レジュメ閲覧"
          primary
          class="mr-4"
      />
      <SelectField
          v-if="messageId && applicationStatus"
          :outlined="false"
          :value="applicationStatus"
          :items="candidateStatus"
          :disabled="applicationStatus === 5"
          simple
          style="max-width: 240px; padding-top: 0; margin-top: 0;"
          @change="onChangeApplicationStatus"
      />
      <JoinDateFormDialog
          :open="openJoinDateDialog"
          :userName="fullName"
          :candidateId="candidate.user.id"
          :jobId="candidate.job.id"
          :status="5"
          @complete="onCompleteJoinDateDialog"
          @cancel="onCancelJoinDateDialog"
      />
      <JoinSideJobFormDialog
          :open="showSideJobDialog"
          :userName="fullName"
          :jobId="candidate.job.id"
          :candidateId="candidate.user.id"
          :status="5"
          @complete="onCompleteJoinSideJobDialog"
          @cancel="onCancelJoinSideJobDialog"
      />
      <JoinCompleteDialog
          :open="openJoinCompleteDialog"
          :isSide="candidate.job.isSide"
          @close="openJoinCompleteDialog = false"
      />
      <FarewellMessageDialog
        :open="openFarewellMessageDialog"
        :user-name="candidate.user.lastName"
        :company-name="company.name"
        :messageId="messageId"
        @cancel="handleCancelFarewellMessage"
        @close="handleCloseFarewellMessage"
      />
    </div>
    <v-snackbar v-model="openSnackbar" color="primary">見送りにしました</v-snackbar>
  </div>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";
import SelectField from "@/components/atoms/SelectField";
import {mapGetters} from "vuex";
import ApiMixin from "@/ApiMixin";
import JoinDateFormDialog from "@/components/organisms/JoinDateFormDialog";
import JoinCompleteDialog from "@/components/organisms/JoinCompleteDialog";
import {jobApplicationStatus} from "@/enums";
import JoinSideJobFormDialog from "@/components/organisms/JoinSideJobFormDialog";
import ApplicantDetailsButton from '../molecules/ApplicantDetailsButton'
import FarewellMessageDialog from './FarewellMessageDialog'
import ApplicationTypeChip from "../molecules/ApplicationTypeChip.vue";
import ExternalLink from "../atoms/ExternalLink.vue";

export default {
  components: {
    ExternalLink,
    ApplicationTypeChip,
    FarewellMessageDialog,
    ApplicantDetailsButton,
    JoinSideJobFormDialog,
    JoinCompleteDialog,
    JoinDateFormDialog,
    SelectField
  },
  mixins: [ComponentMixin, ApiMixin],
  type: "organism",
  name: "MessageCandidateOverview",
  props: {
    candidate: {
      type: Object
    },
    company: {
      type: Object
    },
    messageId: {
      type: String
    },
  },
  data () {
    return {
      applicationStatus: null,
      openJoinDateDialog: false,
      showSideJobDialog: false,
      openJoinCompleteDialog: false,
      openFarewellMessageDialog: false,
      changeStatus: undefined,
      openSnackbar: false
    }
  },
  mounted() {
    this.changeStatus = this.$route.query.status
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    prefecture() {
      return (user) => {
        if (this.consts.prefectures) {
          const prefecture = this.consts.prefectures.find(prefecture => prefecture.value === user.prefecture)
          if (prefecture) {
            return prefecture.label
          }
        }
        return ""
      }
    },
    candidateStatus () {
      if (this.candidate.job.isSide) {
        return jobApplicationStatus.side
      }
      return jobApplicationStatus.regular
    },
    fullName () {
      const lastName = this.candidate.user.lastName || ""
      const firstName = this.candidate.user.firstName || ""
      return lastName + " " + firstName
    },
  },
  methods: {
    onChangeApplicationStatus(status) {
      if (status === 5) {
        this.applicationStatus = 5
        if (this.candidate.job.isSide) {
          this.showSideJobDialog = true
        } else {
          this.openJoinDateDialog = true
        }
      } else if (![0, 1].includes(this.applicationStatus) && status === 6 ) {
        this.applicationStatus = 6
        this.openFarewellMessageDialog = true
      } else {
        this.applyJobForClient(this.candidate.job.id, this.candidate.user.id, status).then(() => {
          this.$emit("change", {status, messageId: this.messageId})
          if (status === 6) {
            this.openSnackbar = true
          }
        })
      }
    },
    onCompleteJoinDateDialog() {
      this.openJoinDateDialog = false
      this.openJoinCompleteDialog = true
      this.$emit("change")
    },
    onCancelJoinDateDialog() {
      this.openJoinDateDialog = false
      this.applicationStatus = this.candidate.applicationStatus
    },
    onCompleteJoinSideJobDialog() {
      this.showSideJobDialog = false
      this.openJoinCompleteDialog = true
      this.$emit("change")
    },
    onCancelJoinSideJobDialog() {
      this.showSideJobDialog = false
      this.applicationStatus = this.candidate.applicationStatus
    },
    handleCancelFarewellMessage() {
      this.openFarewellMessageDialog = false
      this.applicationStatus = this.candidate.applicationStatus
    },
    async handleCloseFarewellMessage() {
      this.applicationStatus = 6;
      await this.applyJobForClient(this.candidate.job.id, this.candidate.user.id, this.applicationStatus)
      this.openFarewellMessageDialog = false
      this.$emit("change", {status: this.applicationStatus, messageId: this.messageId})
    },
  },
  watch: {
    "candidate": {
      handler: function(value) {
        this.applicationStatus = undefined
        this.$nextTick(() => {
          this.applicationStatus = value.applicationStatus
        })
        if (this.changeStatus) {
          this.onChangeApplicationStatus(parseInt(this.changeStatus))
          this.changeStatus = undefined
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
